import moment from "moment";
import 'slick-carousel';
import 'magnific-popup';

jQuery( document ).ready(function($) {
    $('#introvideo')[0].addEventListener('ended',fadeAway,false);
    $()
    function fadeAway(e) {
        $('#introvideo').fadeOut();
    }

    $('.mfp-inline').magnificPopup({
        callbacks: {
            open: function() {
                $('#bg-video')[0].play();
            },
        }
    })

    $('.video-carousel').slick({
        slidesToShow: 1,
        vertical: true,
        verticalSwiping: true,
        arrows: false,
        draggable: true,
    });

    $('.video-carousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
        var currentTitle = $('.video-carousel .slick-active').find('.item').attr('data-title');
        $('.video-control .title').html(currentTitle);
    });

    $('.video-control .next').on('click', function(e) {
        $('.video-carousel').slick('slickNext');
    });
    $('.video-control .prev').on('click', function(e) {
        $('.video-carousel').slick('slickPrev');
    });

    $(window).on('resize orientationchange', function() {
        $('.video-carousel').slick('refresh');
    });

    $('.newsletter').on('submit', function (e) {
		e.preventDefault();
		const DATA = $(this).serialize();

		$.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            dataType: 'json',
            data: DATA,
            xhrFields: {
                withCredentials: false,
            },
            success: function (data) {
				$('.inputs-wrap').html('<p class="newsletter-thanks">Thanks for signing up!</p>');
            },
            error: function (err) {
                console.log(err);
            }
        });
	});

    // Tour
    $.ajax({
        url: "https://rest.bandsintown.com/artists/Black%20Party/events?app_id=45PRESS_blackparty",
        method: "GET",
        dataType: "json",
        xhrFields: {
        withCredentials: false,
        },
        error: () => {},
        success: (data) => {
        const events = $("#events");
        let html = "";
        console.log(data);
        if (data.length) {
            for (let event of data) {
            const event_location = event.venue.city + ", " + event.venue.region;
            html += '<div class="event" data-bit-id="' + event.id + '">';
            
            html += '<div><div class="city">' + event_location + "</div>";
            html +=
                '<div class="event-date">' +
                moment(event.datetime).format("ddd, MMM DD") +
                "</div>";
                
            html += '<div class="event-venue">' + event.venue.name + "</div></div>";
            html += '<div class="event-location">' + event_location + "</div>";
            html += '<div class="event-tickets">';
            html +=
                '<a href="' +
                event.url +
                '" target="_blank" class="btn btn-black">RSVP</a>';
            if (event.offers.length){
                html +=
                '<a href="' +
                event.offers[0].url +
                '" target="_blank" class="btn btn-black">Tickets</a>';
            }
            html += "</div></div>";
            }
            events.html(html);
        } else {
            events.html("No upcoming events.");
        }
        },
    });

    $('.switch').on('click', function(e){
        e.preventDefault();
        let target = $(this).attr('href');
        $('.content section').hide();
        $(target).fadeIn();
        $('body').removeClass()
        $('#header').removeClass('open');
        $('#menu-toggle').removeClass('active');
        $('body').addClass(target.slice(1))
        $('.video-carousel').slick('refresh');
    });

    $('#menu-toggle').on('click', function(e){
        e.preventDefault();
        $('#header').toggleClass('open');
        $('#menu-toggle').toggleClass('active');
    })

    
    $('.content section').hide();
    $('#home').show();
    $('body').addClass('home')

    setTimeout(fadeAway, 3000);
});